/* eslint-disable */

import RaindropInput from "../raindrop-input/raindrop-input.tsx";

import { useState } from "react";
import RaindropButton, {
  ButtonStyle,
} from "../raindrop-button/raindrop-button.tsx";

import {
  fetchOrganisationsActivityPost,
  fetchOrganisationsTransferPost,
  fetchOrganisationsPut,
  fetchGraphQL,
} from "../../services/api-raindrop";

import ModelComponent from "../model-component/model-component.tsx";
import { localize } from "../../services/localize.js";

const OrganisationActionPanel = ({
  organisationId,
  onRefresh,
  setIsEditing,
  organisationStatus,
}) => {
  const onCreateOrganisationTransfer = () => {
    fetchOrganisationsTransferPost({
      organisationId: organisationId,
    }).then((response) => {
      console.log("🟢 (RD-783) - ", response);
      onRefresh();
    });
  };

  const onCreateOrgansationActivity = () => {
    fetchOrganisationsActivityPost({
      organisationId: organisationId,
      heading: "We just did lots of good things!",
    }).then((response) => {
      console.log("🟢 (RD-783) - ", response);
      onRefresh();
    });
  };

  const onToggleStatus = () => {
    let newStatus = "ORGANISATION_STATUS_ACTIVE";
    if (organisationStatus === "ORGANISATION_STATUS_ACTIVE") {
      newStatus = "ORGANISATION_STATUS_INACTIVE";
    }
    fetchOrganisationsPut({
      organisationId: organisationId,
      status: newStatus,
    }).then((response) => {
      console.log("🟢 (RD-783) - ", response);
      onRefresh();
    });
  };

  return (
    <div className={`flex flex-col`}>
      <RaindropButton
        onClick={() => setIsEditing(true)}
        style={ButtonStyle.Secondary}
        title={"Edit"}
        icon="fa-edit"
      />
      <RaindropButton
        title="Create Organisation Transfer"
        icon="fa-exchange"
        style={ButtonStyle.Secondary}
        onClick={onCreateOrganisationTransfer}
      />
      <RaindropButton
        title="Create note"
        icon="fa-notes-medical"
        style={ButtonStyle.Secondary}
        isUnderConstruction={true}
      />
      <RaindropButton
        title="Create activity"
        icon="fa-clipboard-list"
        style={ButtonStyle.Secondary}
        onClick={onCreateOrgansationActivity}
      />
      <RaindropButton
        title="Toggle Status"
        icon="fa-clipboard-list"
        style={ButtonStyle.Secondary}
        onClick={onToggleStatus}
      />
    </div>
  );
};

const ModelComponentOrganisation = ({
  organisationId,
  src,
  title,
  onRefresh,
  rawData = null,
  paymentProviderIdentifierStripe = "",
  status = null,
  organisationType = null,
  urlDonationPage = "",
  publicEmail = "",
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [newName, setNewName] = useState(title);
  const [newUrlDonationPage, setNewUrlDonationPage] = useState(urlDonationPage);
  const [
    newPaymentProviderIdentifierStripe,
    setNewPaymentProviderIdentifierStripe,
  ] = useState(paymentProviderIdentifierStripe);

  const [newPublicEmail, setNewPublicEmail] = useState(publicEmail);

  const onCancel = () => {
    setIsEditing(false);
    setNewName(title);
  };

  const onSubmit = () => {
    setIsSubmitting(true);

    fetchGraphQL(`
      mutation {
        organisationUpdate(
          organisationId: "${organisationId}"
          name: "${newName}"
          paymentProviderIdentifierStripe: "${newPaymentProviderIdentifierStripe}"
          urlDonationPage: "${newUrlDonationPage}"
          publicEmail: "${newPublicEmail}"
        ) {
          id
          
        }
      }
    `)
      .then((data) => {
        setIsEditing(false);
        setIsSubmitting(false);
        console.log("(RD-2343)", data);
      })
      .catch((error) => {
        setIsSubmitting(false);
        console.log(error);
      });
  };

  return (
    <ModelComponent
      modelId={organisationId}
      colorBorderAccent="dark:border-l-color-dark-model-organisation border-l-color-model-organisation"
      dropdownComponent={
        <OrganisationActionPanel
          organisationId={organisationId}
          onRefresh={onRefresh}
          setIsEditing={setIsEditing}
          organisationStatus={status}
        />
      }
      rawData={rawData}
    >
      <RaindropInput
        label="Organisation Name"
        value={newName}
        onChange={(e) => setNewName(e.target.value)}
        icon={null}
        isEditing={isEditing}
        isShowLabel={true}
      />
      <RaindropInput
        label="Stripe Account ID"
        value={newPaymentProviderIdentifierStripe}
        onChange={(e) => setNewPaymentProviderIdentifierStripe(e.target.value)}
        icon={"fa-stripe"}
        isEditing={isEditing}
        isPopulatingExampleIfLocal={false}
        isShowLabel={true}
      />
      <RaindropInput
        label="Donation Page URL"
        value={newUrlDonationPage}
        onChange={(e) => setNewUrlDonationPage(e.target.value)}
        icon={"fa-donation"}
        isEditing={isEditing}
        isPopulatingExampleIfLocal={false}
        isShowLabel={true}
      />
      <RaindropInput
        label="Status"
        value={localize(status)}
        isEditing={false}
        isShowLabel={true}
      />
      <RaindropInput
        label="Type"
        value={localize(organisationType)}
        isEditing={false}
        isShowLabel={true}
      />
      <RaindropInput
        label="Public email"
        value={newPublicEmail}
        onChange={(e) => setNewPublicEmail(e.target.value)}
        isEditing={isEditing}
        isShowLabel={true}
      />

      {isEditing && (
        <div className="flex flex-row w-full">
          <RaindropButton
            onClick={onCancel}
            style={ButtonStyle.Secondary}
            title={"Cancel"}
            icon="fa-cancel"
          />
          <RaindropButton
            title={"Save"}
            icon={"fa-save"}
            onClick={onSubmit}
            isLoading={isSubmitting}
          />
        </div>
      )}
    </ModelComponent>
  );
};

export default ModelComponentOrganisation;
